export const fonts = {
  headings: `'Helvetica Neue', Arial, Helvetica, sans-serif`,
  body: `BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
};
